import { Badge, BadgeProps } from '@mantine/core'
import { IconCrop, IconProps } from '@tabler/icons-react'
import { ReactElement, cloneElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { DatasetType } from '@/types/dataset'

type DatasetTypeConfig = {
  color: string
  text: string
  icon: ReactElement<IconProps> | null
}

const DATASET_TYPE_CONFIG: Record<DatasetType, DatasetTypeConfig> = {
  [DatasetType.Primary]: {
    color: 'brand-primary',
    text: 'datasets.type.primary',
    icon: null
  },
  [DatasetType.Secondary]: {
    color: 'brand-secondary.3',
    text: 'datasets.type.secondary',
    icon: <IconCrop />
  }
}

type DatasetTypeChipProps = {
  size?: BadgeProps['size']
  datasetType: DatasetType
}

export const DatasetTypeChip = ({
  datasetType,
  size = 'xs'
}: DatasetTypeChipProps) => {
  const config = DATASET_TYPE_CONFIG[datasetType]

  if (!config) {
    return null
  }

  return (
    <Badge
      size={size}
      color={config.color}
      leftSection={
        config.icon ? cloneElement(config.icon, { size: 12, stroke: 3 }) : null
      }
      styles={{
        label: {
          userSelect: 'none'
        }
      }}
    >
      <FormattedMessage id={config.text} />
    </Badge>
  )
}
